module.exports = __webpack_public_path__ + "static/media/Snapshot Vid_1733781751010.b60696cd. Script 11 2024";